/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/classnames-order */
import React, { FC } from 'react';
import NextLink from 'next/link';
import { location16Icon, Link } from '@lululemon/b2b-ecom-pattern-library';
import cs from 'classnames';
import { useFormat } from 'helpers/hooks/useFormat';
import { useBusinessUnit } from 'frontastic';
import styles from '../top-nav-desktop/top-nav-desktop-bar.module.scss';

const ShippingLocation: FC = () => {
  const { formatMessage } = useFormat({ name: 'account' });
  const { defaultShippingAddress } = useBusinessUnit();
  const {
    addressLine1 = '',
    addressLine2 = '',
    city = '',
    state = '',
    postalCode = '',
    country = '',
  } = defaultShippingAddress || {};

  const displayDefaultShippingAddress =
    defaultShippingAddress && `${addressLine1} ${addressLine2}, ${city}, ${state} ${postalCode}, ${country}`;

  return (
    <NextLink href="/account#addresses" passHref>
      <Link
        tag="span"
        className={cs('flex cursor-pointer', 'lll-type-body-small', styles.shippingLink)}
        icon={location16Icon}
        id="top-nav-shipping-location"
        variant="underlineAnimated"
      >
        {displayDefaultShippingAddress
          ? displayDefaultShippingAddress
          : formatMessage({
              id: 'add.shipping.address',
              defaultMessage: 'Add Shipping Address',
            })}
      </Link>
    </NextLink>
  );
};

export default ShippingLocation;
